import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {Location} from '@angular/common'

@Component({
  selector: 'app-auth-login',
  templateUrl: './help.component.html',
  imports: [
    RouterLink
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpComponent {
  constructor(private location: Location) {
  }

  public back() {
    this.location.back();
  }
}
